export class OrdreTachePmsDto {
  value: number;
}
